import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconCollection, Map } from '../';
import { getLocationText, normalizeDeliveryOptions } from '../../util/data.js';
import css from './ItemLocation.module.css';

const ItemLocation = ({ location, currentUserLocationInfo, access_to_rentals }) => {
    if ((!location || !location.selectedPlace) && !currentUserLocationInfo) return null;
    const { address, city, region, state, origin } = location?.selectedPlace || currentUserLocationInfo;
    const mapProps = {
        address,
        center: origin,
    };

    const locationText = getLocationText(city, region, state);

    const normalisedAccessibilityOptions = normalizeDeliveryOptions(access_to_rentals || []).join(', ');
    const mainHeading = !!normalisedAccessibilityOptions
        ? `This item is available for ${normalisedAccessibilityOptions}${locationText}`
        : `This item is available for rental ${locationText}`

    return (
        <div className={css.panel}>
            <h4 className={css.heading}>Item Location</h4>
            <div className={css.text}>
                {mainHeading}
            </div>
            {mapProps && <div className={css.mapBox}><Map {...mapProps} /></div>}
            {mapProps && (
                <Button className={css.directionBtn}  variant='danger' arrow="right" icon={<IconCollection name="map_pin"/>}> 
                    Get Direction
                </Button>
            )}
        </div>
    );
};

ItemLocation.propTypes = {
    location: PropTypes.shape({
        selectedPlace: PropTypes.shape({
            address: PropTypes.string,
            city: PropTypes.string,
            region: PropTypes.string,
            state: PropTypes.string,
            origin: PropTypes.object,
        }),
    }),
    access_to_rentals: PropTypes.array,
};

export default ItemLocation; 